export interface INumber {
  id: number
  partner_global_id: number
  user_global_id: number
  application_type: string
  type: string
  region_code: string
  phone_number: string
  display_name: string
  deleted_at: null | string
  created_at: string
  updated_at: string
}

export interface IAvailableNumber {
  active?: boolean
  createdAt?: string
  displayName?: string
  driver?: string
  id: number
  partnerGlobalId?: string | number | null
  phoneNumber?: string
  regionCode?: string
  syncAt?: string
  updatedAt?: string
  account?: {
    id: number
    userId: number
    identifier: string
    internalId: null
    driver: string
    status: string
    createdAt: string
    updatedAt: string
  }
  number: {
    id: number
    partnerGlobalId: number
    driver: string
    regionCode: string
    phoneNumber: string
    displayName: string
    active: boolean
    syncAt: string
    createdAt: string
    updatedAt: string
  }
}

export enum PlaceVariables {
  START_WITH = 'start_with',
  CONTAINS = 'contains',
  ENDS_WITH = 'ends_with',
}
